import React from 'react';
import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { Creators as DocumentoActions } from '../ducks/documento';

import { CheckListDocumentosAPI } from '../../services/api';

import {
  WarningToast,
  ErrorToast,
  SuccessToast,
} from '../../components/molecules/Toast';

export function* postDocumentosImportacao(action) {
  const { files, idLista } = action;
  const isImportSuccess = [];

  try {
    yield* files.map(function* (file) {
      try {
        const fileFormat = {
          idLista,
          arquivo: file.base64,
          nomeArquivo: file.name,
          idHub: null,
        };

        const response = yield call(
          CheckListDocumentosAPI.post,
          `/documentos-importacao`,
          fileFormat
        );

        const { success, message } = response.data;

        isImportSuccess.push(success);

        yield put(
          DocumentoActions.postDocumentosImportacaoUpdateFile(
            file.idFile,
            success,
            100,
            message
          )
        );

        if (!success) {
          throw new Error(message);
        }
      } catch (err) {
        if (err.message) {
          toast.error(
            <ErrorToast size="30">
              Erro ao carregar o arquivo:
              <br />
              <strong>{file.name}</strong>.
              <br />
              {err.message}
            </ErrorToast>
          );
        }
      }
    });

    const isSuccess = isImportSuccess.every((resp) => !!resp);
    const isPartialSuccess = isSuccess
      ? false
      : isImportSuccess.some((resp) => !!resp);
    const isError = isImportSuccess.every((resp) => !resp);

    if (isError) {
      yield put(
        DocumentoActions.postDocumentosImportacaoResponse(
          false,
          {},
          'Documentos invalidos'
        )
      );
      return;
    }

    if (isSuccess)
      toast.success(
        <SuccessToast size="30">
          Doumentos(s) carregado(s) com sucesso.
        </SuccessToast>
      );

    if (isPartialSuccess)
      toast.success(
        <SuccessToast size="30">
          Doumentos(s) válido(s) carregado(s) com sucesso.
        </SuccessToast>
      );

    yield put(
      DocumentoActions.postDocumentosImportacaoResponse(true, {}, null)
    );
  } catch (error) {
    yield put(
      DocumentoActions.postDocumentosImportacaoResponse(false, null, error)
    );
  }
}

export function* getDocumentosBeneficiario(action) {
  const { idLista } = action;

  try {
    const { status, data } = yield call(
      CheckListDocumentosAPI.get,
      `/documentos-importacao/${idLista}/beneficiario-documento`
    );

    const success = status === 200 || false;
    if (success) {
      yield put(
        DocumentoActions.getDocumentosBeneficiarioResponse(
          success,
          data?.data,
          null
        )
      );
      return;
    }
    throw new Error('Não foi possivel acessar os detalhes de documentos.');
  } catch (error) {
    toast.error(
      <ErrorToast size="30">
        Não foi possivel acessar os detalhes de documentos.
      </ErrorToast>
    );
  }
}

export function* getDocumentoPreview(action) {
  const { idLista, idDocumento } = action;

  try {
    const { status, data } = yield call(
      CheckListDocumentosAPI.get,
      `/documentos-importacao/${idLista}/preview-documento/${idDocumento}`
    );

    const success = status === 200 || false;
    if (success) {
      yield put(
        DocumentoActions.getDocumentoPreviewResponse(success, data?.data, null)
      );
      return;
    }
    throw new Error('Não foi possivel acessar o preview do documento.');
  } catch (error) {
    toast.error(
      <ErrorToast size="30">
        Não foi possivel acessar o preview do documento.
      </ErrorToast>
    );
  }
}

export function* postAtualizarDocumentoConferencia(action) {
  const { idLista, params, callbackSuccess } = action;
  const { idArquivo: idDocumento } = params;

  try {
    const { data } = yield call(
      CheckListDocumentosAPI.post,
      `/documentos-importacao/${idLista}/atualiza-documento-conferencia/${idDocumento}`,
      { ...params }
    );

    if (data.success) {
      toast.success(<SuccessToast size="30">{data.message}</SuccessToast>);
      yield put(
        DocumentoActions.postAtualizarDocumentoConferenciaResponse(
          data.success,
          data?.data,
          null
        )
      );
      callbackSuccess();
      return;
    }

    throw new Error(data.message || 'Erro ao aceitar/recusar o arquivo.');
  } catch (error) {
    toast.error(
      <ErrorToast size="30">
        {error?.message || 'Erro ao aceitar/recusar o arquivo.'}
      </ErrorToast>
    );
  }
}

export function* postFinalizarConferenciaDocumentos(action) {
  const { idLista, callbackSuccess } = action;

  try {
    const { data } = yield call(
      CheckListDocumentosAPI.post,
      `/documentos-importacao/${idLista}/finaliza-conferencia`
    );

    if (data.success) {
      toast.success(<SuccessToast size="30">{data.message}</SuccessToast>);
      yield put(
        DocumentoActions.postFinalizarConferenciaDocumentosResponse(
          data.success,
          data?.data,
          null
        )
      );
      callbackSuccess();
      return;
    }

    throw new Error(data.message || 'Erro ao aceitar/recusar o arquivo.');
  } catch (error) {
    yield put(
      DocumentoActions.postFinalizarConferenciaDocumentosResponse(
        false,
        {},
        error
      )
    );
    toast.error(
      <ErrorToast size="30">
        {error?.message || 'Erro ao aceitar/recusar o arquivo.'}
      </ErrorToast>
    );
  }
}
